import CashFlowReport from '@/components/OptimizationReports/CashflowReport/CashflowReport'
import ConstraintReport from '@/components/OptimizationReports/ConstraintReport/ConstraintReport'
import SummaryReport from '@/components/OptimizationReports/SummaryReport/SummaryReport'
import TransactionReport from '@/components/OptimizationReports/TransactionReport/TransactionReport'
import SplitButton from '@/components/Shared/SplitButton'
import { FLEX_ROW_SPACE_BETWEEN } from '@/constants/scenarioBuilder.constant'
import { ReportsTab } from '@/enums/portfolio-optimization.enum'
import { PortfolioOptimizationLayout } from '@/Layouts/PortfolioOptimizationLayout'
import { AgGridReact } from '@ag-grid-community/react'
import { Box, Paper, Tab, Tabs } from '@mui/material'
import React, { useState } from 'react'

const PortfolioOptimizationRunReportsPage: React.FC = () => {
  const [tabIndex, setTabIndex] = useState(0)
  const [gridReference, setGridReference] = useState<AgGridReact>()
  const handleChange = (event: any, index: number) => {
    setTabIndex(index)
  }
  const handleOptionSelect = (index: number, option: string) => {
    const exportType = index === 0 ? 'EXCEL' : 'CSV'
    switch (exportType) {
      case 'CSV':
        gridReference?.current?.api.exportDataAsCsv()
        break
      case 'EXCEL':
        gridReference?.current!.api.exportDataAsExcel()
        break
    }
  }
  return (
    <PortfolioOptimizationLayout>
      <Paper
        sx={{
          minHeight: 'calc(100vh - 68px - 16px )',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            ...FLEX_ROW_SPACE_BETWEEN,
            borderBottom: '1px solid #E5E5E5',
            padding: 1,
          }}
        >
          <Tabs
            value={tabIndex}
            onChange={handleChange}
            aria-label='Portfolio Activity Tabs'
          >
            <Tab label='Transaction Report' />
            <Tab label='Constraint Report' />
            <Tab label='Summary Report' />
            {/* 
              Cash Flow Report tab - Always visible (removed conditional rendering)
              Now: Always renders regardless of liability selection in optimization parameters
            */}
            <Tab label='Cash Flow Report' />
          </Tabs>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <SplitButton
              options={['Export as Excel', 'Export as CSV']}
              buttonLabel='Report Actions'
              onOptionSelect={handleOptionSelect}
              disabled={
                tabIndex === ReportsTab.ConstraintReport ||
                tabIndex === ReportsTab.SummaryReport
                  ? true
                  : false
              }
            />
          </Box>
        </Box>
        {tabIndex === ReportsTab.TransactionReport && (
          <TransactionReport setGridReference={setGridReference} />
        )}
        {tabIndex === ReportsTab.ConstraintReport && <ConstraintReport />}
        {tabIndex === ReportsTab.SummaryReport && <SummaryReport />}
        {/* 
          Cash Flow Report content - Always renders when tab is selcted, regardless of Redux showCashflowReport state
          The component itself handles the no-data message when liabilities are not specified
        */}
        {tabIndex === ReportsTab.CashFlowReport && (
          <CashFlowReport setGridReference={setGridReference} />
        )}
      </Paper>
    </PortfolioOptimizationLayout>
  )
}

export default PortfolioOptimizationRunReportsPage
